module.exports = __webpack_public_path__ + "static/media/JPMC.277b43d1.svg";